import type { Locale } from '@seek/melways-sites';
import { useTranslations } from '@vocab/react';
import { Box, Stack, Text, Heading } from 'braid-design-system';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';

import type { IProspectEmailStore } from '../../../stores/JobApplicationStore/ProspectEmailStore';

import translations from './.vocab/';
import EmptyEmailIcon from './EmptyEmailIcon';
import ProspectEmailList from './ProspectEmailList';
import SendProspectEmail from './SendProspectEmail';

import * as styles from './ProspectEmail.css';

interface Props {
  prospectEmailStore: IProspectEmailStore;
  locale: Locale;
}

const ProspectEmail = ({ prospectEmailStore, locale }: Props) => {
  const { t } = useTranslations(translations);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    prospectEmailStore.loadEmails();
  }, [prospectEmailStore]);

  return (
    <Box marginBottom="medium" className={styles.emailContainer}>
      <Stack space="medium">
        <Heading level="3">{t('Emails')}</Heading>
        <Stack space="small">
          <SendProspectEmail
            showForm={showForm}
            setShowForm={setShowForm}
            prospectEmailStore={prospectEmailStore}
          />

          {prospectEmailStore.emailCount === 0 ? (
            <>
              <Box padding="large" display="flex" justifyContent="center">
                {!showForm && (
                  <Stack space="medium">
                    <Box display="flex" justifyContent="center">
                      <EmptyEmailIcon />
                    </Box>
                    <Text weight="strong">
                      {t('No emails message...', {
                        fullName: prospectEmailStore.jobApplication.fullName,
                      })}
                    </Text>
                  </Stack>
                )}
              </Box>
            </>
          ) : (
            <Box marginTop="small">
              <ProspectEmailList
                prospectEmailStore={prospectEmailStore}
                locale={locale}
              />
            </Box>
          )}
        </Stack>
      </Stack>
    </Box>
  );
};

export default observer(ProspectEmail);
